export const l_grid_item_Order = {
  "name": "--pf-v6-l-grid--item--Order",
  "value": "0",
  "var": "var(--pf-v6-l-grid--item--Order)"
};
export default l_grid_item_Order;